import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';
import type { UrlParamsAdapter } from '../types';

//creates a UrlParamsAdapter backed by React Router's useSearchParams.
//must be called inside a component (it's a hook).
export function useReactRouterAdapter(): UrlParamsAdapter {
  const [searchParams, setSearchParams] = useSearchParams();

  return useMemo<UrlParamsAdapter>(
    () => ({
      get() {
        return searchParams;
      },
      set(params, options) {
        setSearchParams(params, { replace: options?.replace ?? true });
      },
    }),
    [searchParams, setSearchParams]
  );
}
